/* eslint-env browser, node, process */
/* eslint-disable no-console */
import Vue from 'vue';
import App from './App.vue';
import AppMenu from './AppMenu.vue';
import store from './store/index.js';
import router from './router/index.js';
// import ie11RouterFix from './router/ie11-fix.js';
import { mapActions, mapGetters } from 'vuex';
import { clearCache } from './services/cache.js';
/* eslint-disable-next-line no-unused-vars */
import { homeDataLogic, browsingDataLogic, searchDataLogic, selectedDataLogic, industryDataLogic, divisionDataLogic } from './services/data-logic.js';
import webStorage from './services/web-storage.js';

// Define NODE_ENV=development in your .env file to disable cache clearing on reload
if (!(process && process.env && process.env.NODE_ENV && process.env.NODE_ENV === 'development')) {
  window.onbeforeunload = function(){
    if ('caches' in window) {
      clearCache();
    }
  }
} else {
  console.log('Development mode: clearing cache disabled.');
}


const rootMenu = document.getElementById('bic-search-menu');
if (rootMenu) {
  console.log('#bic-search-menu');
  new Vue({
    el: '#bic-search-menu',
    store,
    router,
    // mixins: [ie11RouterFix],
    render: function render(h) {
      return h(AppMenu, {
        props: {
          // -- router --
          mode: this.$store.state.mode,
        }
      })
    }
  });
}


const root = document.getElementById('bic-search');
if (root) {
  new Vue({
    el: '#bic-search',
    mounted: function () {
      const routeName = this.$route.name;
      this[`${routeName}Init`](this.$route);
      // initialize bicsSelected from sessionStorage (If user navigates from a route that is not handled by the app lik /help)
      const bicsSelected = webStorage.get('bicsSelected');
      if (bicsSelected) {
        this.$store.dispatch('initSelectedBics', { bicsSelected });
      }
    },
    router,
    store,
    methods: {
      ...mapActions({
        searchSubmit: 'updateTerm',
        browseSubmit: 'browseBics', // moved to data logic
        getBicsByCodes: 'getBicsByCodes', // moved to data logic
        getAlternateBic: 'getAlternateBic',
        clearAlternateBic: 'clearAlternateBic',
        getIndustries: 'getIndustries',
        updateIndustry: 'updateIndustry',
        updateSector: 'updateSector',
        updateCategory: 'updateCategory',
        addToWatchlist: 'addToWatchlist',
        removeFromWatchlist: 'removeFromWatchlist',
        clearWatchlist: 'clearWatchlist',
        toggleBicsHelp: 'toggleBicsHelp',
        setShowSelected: 'setShowSelected',
        setDisplayList: 'setDisplayList',
      }),
      searchSubmitRouter: function(payload) { 
        this.$router.push({ name: 'search', query: { searchTerm: payload.term } });
      },
      browseSubmitRouter: function(payload) { 
        this.$router.push({ name: 'browsing', params: { category: payload.category }});
      },
      homeInit: homeDataLogic.init,
      browsingInit: browsingDataLogic.init,
      selectedInit: selectedDataLogic.init,
      searchInit: searchDataLogic.init,
      industryInit: industryDataLogic.init,
      divisionInit: divisionDataLogic.init,
    },
    // only implemented to store the bicSelected array in SessionStorage
    computed: {
      ...mapGetters(['getBicsSelected'])
    },
    watch: {
      $route(to) {
        this[`${to.name}Init`](to);
        // Error handling ???
        // this.$router.replace({ path: '/' });
      },
      getBicsSelected(bicsSelected){
        webStorage.set('bicsSelected', bicsSelected);
      }
    },
    render: function render(h) {
      return h(App, {
        props: {
          // -- router --
          mode: this.$store.state.mode,
          routeName: this.$route.name, // the help message is different for browse/class and browse/industry or browse/division
          // -- store --
          // misc
          term: this.$store.state.term,
          helpForSearchTerm: this.$store.state.helpForSearchTerm,
          loading: this.$store.state.loading,
          messageType: this.$store.state.messageType,
          message: this.$store.state.message,
          bics: this.$store.state.bics,
          bicsSelected: this.$store.state.bicsSelected,

          alternateBicSource: this.$store.state.alternateBicSource,
          alternateBic: this.$store.state.alternateBic,
          alternateBicLoading: this.$store.state.alternateBicLoading,

          showSelected: this.$store.state.showSelected,
          displayList: this.$store.state.displayList,
          bicsHelp: this.$store.state.bicsHelp,
          // industry
          industry: this.$store.state.industry,
          industryOptions: this.$store.state.industryOptions,
          industryLoading: this.$store.state.industryLoading,
          // sector
          sector: this.$store.state.sector,
          sectorOptions: this.$store.state.sectorOptions,
          sectorLoading: this.$store.state.sectorLoading,
          // category
          category: this.$store.state.category,
          categoryOptions: this.$store.state.categoryOptions,
          categoryLoading: this.$store.state.categoryLoading,
          // methods / actions
          // searchSubmit: this.searchSubmit,
          searchSubmit: this.searchSubmitRouter,
          // browseSubmit: this.browseSubmit,
          browseSubmit: this.browseSubmitRouter,
          getAlternateBic: this.getAlternateBic,
          clearAlternateBic: this.clearAlternateBic,
          updateIndustry: this.updateIndustry,
          updateSector: this.updateSector,
          updateCategory: this.updateCategory,
          addToWatchlist: this.addToWatchlist,
          removeFromWatchlist: this.removeFromWatchlist,
          clearWatchlist: this.clearWatchlist,
          toggleBicsHelp: this.toggleBicsHelp,
          setShowSelected: this.setShowSelected,
          setDisplayList: this.setDisplayList,
        }
      })
    }
  });
}